import React, { useState, useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "./KeyValueContainer.css";

const KeyValueContainer = ({ rowData, columns }) => {
  const [micInfo, setMicInfo] = useState([]);
  const [micColumns, setMicColumns] = useState([]);

  useEffect(() => {
    rowData.forEach(micInfo => {
      if (micInfo?.mic_information?.length > 0) {
        const columns = micInfo.mic_information.map(info => 
          Object.keys(info).map(key => ({
            dataField: key,
            text: key.replace(/_/g, " ").toUpperCase(),
          }))
        );
        setMicInfo(micInfo.mic_information);
        setMicColumns(columns[0]);
      }
    });
  }, [rowData]);

  const micInfoTable = useMemo(() => {
    if (micInfo.length > 0) {
      return (
        <div className="mic-container">
          <h4>Mic Information</h4>
          <BootstrapTable columns={micColumns} data={micInfo} keyField="id" />
        </div>
      );
    }
    return null;
  }, [micInfo, micColumns]);

  return (
    <div className="attribute-container">
    <h4>Attributes</h4>
      <div className="key-value-container">
        {columns
          .filter(field => field.dataField !== "mic_information")
          .map(field => (
            <div className="key-value-pair" key={field.dataField}>
              <div className="key">{field.text}</div>
              {rowData.map((row, index) => (
                <div className="value" key={index}>
                  {row[field.dataField]}
                </div>
              ))}
            </div>
          ))}
      </div>
      {micInfoTable}
    </div>
  );
};

export default KeyValueContainer;
